import { render } from "./GroButton.vue?vue&type=template&id=3bb2047c&scoped=true"
import script from "./GroButton.vue?vue&type=script&lang=js"
export * from "./GroButton.vue?vue&type=script&lang=js"

import "./GroButton.vue?vue&type=style&index=0&id=3bb2047c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bb2047c"

export default script